import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      category: '服务相关',
      questions: [
        {
          q: '服务价格如何计算？',
          a: '服务价格根据项目规模、复杂程度、服务内容等因素综合确定。我们提供透明报价，具体价格需要根据您的项目需求进行评估。'
        },
        {
          q: '服务周期多长？',
          a: '服务周期根据项目规模和复杂程度而定。一般概预算审核项目为5-10个工作日，全过程造价咨询根据项目周期确定。'
        },
        {
          q: '需要提供哪些资料？',
          a: '通常需要提供项目图纸、设计文件、合同文件等相关资料。具体资料清单我们会根据项目情况提供。'
        },
        {
          q: '如何保证服务质量？',
          a: '我们拥有完善的质量管理体系，所有项目都经过多级审核，确保服务质量。同时我们提供质量承诺和售后保障。'
        }
      ]
    },
    {
      category: '数智平台相关',
      questions: [
        {
          q: '数智平台如何使用？',
          a: '数智平台需要注册账号并登录使用。我们提供详细的使用说明和培训服务，帮助您快速上手。'
        },
        {
          q: '平台是否需要收费？',
          a: '平台基础功能免费使用，高级功能根据使用情况收费。具体收费标准请咨询我们的客服。'
        },
        {
          q: '如何申请平台账号？',
          a: '您可以通过官网联系我们，或直接拨打客服电话申请平台账号。我们会为您开通账号并提供使用指导。'
        }
      ]
    },
    {
      category: '合作相关',
      questions: [
        {
          q: '如何开始合作？',
          a: '您可以通过官网在线咨询、电话或邮件联系我们。我们会安排专业顾问与您沟通，了解需求后提供方案和报价。'
        },
        {
          q: '合同签订流程？',
          a: '确定合作意向后，我们会提供正式合同。双方确认无误后签署合同，即可开始项目合作。'
        },
        {
          q: '付款方式？',
          a: '支持银行转账、支票等多种付款方式。具体付款方式和时间节点在合同中明确约定。'
        }
      ]
    }
  ];

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <main className="faq-page">
      <div className="faq-hero">
        <div className="container">
          <h1>常见问题</h1>
          <p>为您解答常见疑问</p>
        </div>
      </div>

      <div className="faq-content">
        <div className="container">
          {faqs.map((category, catIndex) => (
            <div key={catIndex} className="faq-category">
              <h2>{category.category}</h2>
              <div className="faq-list">
                {category.questions.map((item, index) => {
                  const globalIndex = catIndex * 100 + index;
                  const isOpen = openIndex === globalIndex;
                  
                  return (
                    <div key={index} className={`faq-item ${isOpen ? 'open' : ''}`}>
                      <button
                        className="faq-question"
                        onClick={() => toggleQuestion(globalIndex)}
                      >
                        <span>{item.q}</span>
                        {isOpen ? <FiChevronUp /> : <FiChevronDown />}
                      </button>
                      {isOpen && (
                        <div className="faq-answer">
                          <p>{item.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          <div className="faq-cta">
            <h3>还有其他问题？</h3>
            <p>我们的专业团队随时为您解答</p>
            <a href="/contact" className="btn btn-primary">联系我们</a>
          </div>
        </div>
      </div>
    </main>
  );
};

export default FAQ;
